import { useTranslation } from "@opendash/i18n";
import { Alert } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";

type Props = {};

export const TemplateHeaderExtra = observer((props: Props) => {
  const t = useTranslation();
  return (
    <Alert
      type="info"
      message={t("maintenance:schedules.admin.headerextra")}
      style={{ marginBottom: 12 }}
    />
  );
});
